import { Component, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { NgForm } from '@angular/forms';
import { UserService } from '../../dataServices/userService';
import { User } from '../../models/user';
import { AppState } from '../../services/app.service';

@Component({
    selector: 'self-ins-verification',
    templateUrl: './verification-page.component.html',
    styleUrls: ['./verification-page.component.scss']
})
export class VerificationPageComponent {
    @ViewChild('form', { static: false }) public form: NgForm | undefined = undefined;
    public user: User | undefined;
    public constructor(private router: Router,
                       private userService: UserService,
                       private appState: AppState) {
        this.userService.getUserVerificationInfo().subscribe((data) => {
            this.user = this.appState.user.getValue();
            this.user.verificationInfo = data;
            this.appState.updateUser(this.user);
        })
    }

    public onSubmit() {
        this.userService.getQuote().subscribe((data) => {
            if (data) {
                if (this.user && this.user.status === 'provisioning') {
                    this.router.navigate(['/verification-tractors', data.qnum, data.qsuffix]);
                    return;
                }
                this.router.navigate(['/coverage']);
            }
        })
    
    }
}